import { render, staticRenderFns } from "./CDP.vue?vue&type=template&id=18ac243a&scoped=true&"
import script from "./CDP.vue?vue&type=script&lang=js&"
export * from "./CDP.vue?vue&type=script&lang=js&"
import style0 from "./CDP.vue?vue&type=style&index=0&id=18ac243a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac243a",
  null
  
)

export default component.exports